import React, { Fragment, useContext, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

import LoadingContext from '../../context/Loading/Loading'
import { getPublicFundraisingCampaign } from '../../utilities/api'
import {
  FundraisingCampaignWrapper,
  PageLoadingContainer,
} from '../../components'
import NotFoundPage from '../NotFoundPage/NotFoundPage'

export default function FundraisingCampaignPage() {
  const { slug, campaignSlug, orgSlug } = useParams()
  const [searchParams] = useSearchParams()
  const organizationUUID = searchParams.get('organizationUUID') || undefined
  const resolvedCampaignSlug = campaignSlug || slug
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)
  const [campaign, setCampaign] = useState(null)
  const [loadError, setLoadError] = useState('')

  useEffect(() => {
    if (!resolvedCampaignSlug) return

    showLoading()
    setLoadError('')

    getPublicFundraisingCampaign(resolvedCampaignSlug, {
      organizationUUID,
      organizationSlug: orgSlug,
    })
      .then((res) => {
        setCampaign(res?.data?.campaign || null)
      })
      .catch((error) => {
        console.error('Failed to load public fundraising campaign:', error)
        setCampaign(null)
        setLoadError('This fundraiser is unavailable or no longer active.')
      })
      .finally(() => hideLoading())
  }, [resolvedCampaignSlug, organizationUUID, orgSlug])

  return (
    <Fragment>
      <Helmet>
        <title>
          {campaign?.title ? `${campaign.title} | Fundraiser` : 'Fundraiser'}
        </title>
        <meta
          name="description"
          content={
            campaign?.description || 'Support this fundraising campaign.'
          }
        />
      </Helmet>
      {isLoading ? (
        <PageLoadingContainer />
      ) : campaign ? (
        <section className="background-gradient fundraiser-page-section pb-4 full-height">
          <FundraisingCampaignWrapper
            campaign={campaign}
            organizationUUID={organizationUUID}
            organizationSlug={orgSlug}
          />
        </section>
      ) : (
        <NotFoundPage
          title="Fundraiser not found"
          message={
            loadError ||
            'This campaign may be unpublished, expired, or the link may be incorrect.'
          }
        />
      )}
    </Fragment>
  )
}
